module.exports = __webpack_public_path__ + "static/media/bg-image-15.4b082504.jpg";